import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import { DtwinLifeCycleState } from "~/modules/dtwin/models/DtwinLifeCycleState.enum";
import type { DtwinModel } from "~/modules/dtwin/models/DtwinModel.interface";

export function canUpdateDtwinLifeCycleState(
  dtwin: Dtwin,
  dtwinModel?: DtwinModel,
) {
  // can enable the device if it is disabled
  if (dtwin.lifeCycleState === DtwinLifeCycleState.DISABLED) {
    return true;
  }
  // base on the device model transitions, can disable the device if a transition exists from current life cycle state to the disabled state
  else if (dtwinModel) {
    // get the transitions to disabled state
    const transitionsToDisabled = dtwinModel.lifeCycle.transitions.filter(
      (transition) => transition.to.includes(DtwinLifeCycleState.DISABLED),
    );

    // check if one of the transitions to disable state exists from the current life cycle state
    for (const transitionToDisabled of transitionsToDisabled) {
      if (transitionToDisabled.from === dtwin.lifeCycleState) {
        return true;
      }
    }

    return false;
  }
}
